import { useState, useEffect } from 'react';
import {
  axiosCandidateContactDetails,
  getHiringManagerDetails,
} from '../stateManagement/api';
import {
  ICandidatesContactDetailsPayload,
  IReqCandidatesContactDetails,
} from '../models/IRequisitionCandidates.interface';

const useCandidateContactDetails = (candidateId: number | undefined) => {
  const [contactDetailsData, setContactDetailsData] =
    useState<IReqCandidatesContactDetails>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { nimbleOrgId } = await getHiringManagerDetails();
        setLoading(true);

        const payload: ICandidatesContactDetailsPayload = {
          candidateId,
          orgId: nimbleOrgId,
        };
        const response = await axiosCandidateContactDetails(payload);
        setContactDetailsData(response);
        setError(null);
      } catch (apiError: any) {
        setError(apiError.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [candidateId]);

  return { contactDetailsData, loading, error };
};

export default useCandidateContactDetails;
